function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm4.293-.707a1 1 0 011.414 0L7 8.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-2-2a1 1 0 010-1.414z",
  fill: "#25DA4D"
});

function SvgCheckCircle16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDhDMCAxMi40MTgzIDMuNTgxNzIgMTYgOCAxNkMxMi40MTgzIDE2IDE2IDEyLjQxODMgMTYgOEMxNiAzLjU4MTcyIDEyLjQxODMgMCA4IDBDMy41ODE3MiAwIDAgMy41ODE3MiAwIDhaTTQuMjkyODkgNy4yOTI4OUM0LjY4MzQyIDYuOTAyMzcgNS4zMTY1OCA2LjkwMjM3IDUuNzA3MTEgNy4yOTI4OUw3IDguNTg1NzlMMTAuMjkyOSA1LjI5Mjg5QzEwLjY4MzQgNC45MDIzNyAxMS4zMTY2IDQuOTAyMzcgMTEuNzA3MSA1LjI5Mjg5QzEyLjA5NzYgNS42ODM0MiAxMi4wOTc2IDYuMzE2NTggMTEuNzA3MSA2LjcwNzExTDcuNzA3MTEgMTAuNzA3MUM3LjMxNjU4IDExLjA5NzYgNi42ODM0MiAxMS4wOTc2IDYuMjkyODkgMTAuNzA3MUw0LjI5Mjg5IDguNzA3MTFDMy45MDIzNyA4LjMxNjU4IDMuOTAyMzcgNy42ODM0MiA0LjI5Mjg5IDcuMjkyODlaIiBmaWxsPSIjMjVEQTREIi8+Cjwvc3ZnPgo=";
export { SvgCheckCircle16 as ReactComponent };